import React, { useState, useEffect } from 'react';

const Navbar = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 20);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const navLinks = [
        { name: 'Features', href: '#features' },
        { name: 'Traceability', href: '#traceability' },
        { name: 'Analysis', href: '#analysis' },
        { name: 'Audit', href: '#audit' },
        { name: 'Pricing', href: '#pricing' },
        { name: 'FAQ', href: '#faq' },
    ];

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || isMenuOpen ? 'glass py-4 shadow-sm' : 'bg-transparent py-6'}`}>
            <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
                <div
                    className="flex items-center gap-2 sm:gap-3 group cursor-pointer relative z-50"
                    onClick={scrollToTop}
                >
                    <div className="w-10 h-10 sm:w-14 sm:h-14 overflow-hidden rounded-full shadow-lg transition-transform group-hover:scale-105 flex items-center justify-center bg-white/10 backdrop-blur-sm border border-white/20">
                        <img src="/logo-omni.png" alt="OmniTraceX Logo" className="w-full h-full object-contain p-0.5" />
                    </div>
                    <span className="text-base sm:text-2xl font-bold tracking-tight text-slate-900">OmniTrace<span className="text-sky-500">X</span></span>
                </div>

                <div className="hidden md:flex items-center gap-8">
                    {navLinks.map(link => (
                        <a key={link.name} href={link.href} className="text-slate-600 hover:text-sky-500 font-medium transition-colors">{link.name}</a>
                    ))}
                </div>

                <div className="flex items-center gap-1.5 sm:gap-4 relative z-50">
                    <button
                        className="hidden sm:block text-slate-600 hover:text-sky-500 font-medium transition-colors"
                        onClick={() => window.open('https://portal.omnitracex.vetobase.com', '_blank')}
                    >
                        Log in
                    </button>
                    <button
                        className="btn-primary px-3 py-1.5 sm:px-6 sm:py-3 text-[11px] sm:text-base"
                        onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                    >
                        Get Started
                    </button>

                    {/* Mobile Menu Toggle */}
                    <button
                        className="md:hidden p-2 text-slate-600 hover:text-indigo-600 transition-colors"
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                    >
                        {isMenuOpen ? (
                            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        ) : (
                            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        )}
                    </button>
                </div>
            </div>

            {/* Mobile Menu Dropdown */}
            <div className={`md:hidden absolute top-[90%] left-4 right-4 bg-white rounded-3xl border border-slate-100 shadow-2xl overflow-hidden transition-all duration-500 ease-in-out ${isMenuOpen ? 'opacity-100 translate-y-0 visible' : 'opacity-0 -translate-y-4 invisible'}`}>
                <div className="px-6 py-8 flex flex-col gap-5">
                    {navLinks.map(link => (
                        <a
                            key={link.name}
                            href={link.href}
                            onClick={() => setIsMenuOpen(false)}
                            className="text-lg font-bold text-slate-900 hover:text-sky-500 flex items-center justify-between group transition-colors"
                        >
                            {link.name}
                            <svg className="w-4 h-4 opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M9 5l7 7-7 7" />
                            </svg>
                        </a>
                    ))}
                    <div className="h-px bg-slate-50 w-full my-1" />
                    <button
                        className="w-full py-4 text-center font-bold text-slate-600 hover:text-slate-900 transition-colors"
                        onClick={() => window.open('https://portal.omnitracex.vetobase.com', '_blank')}
                    >
                        Log in
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
